import { render, staticRenderFns } from "./HotelDetailsMobile.vue?vue&type=template&id=0c4fc3ce&scoped=true"
import script from "./HotelDetailsMobile.vue?vue&type=script&lang=js"
export * from "./HotelDetailsMobile.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailsMobile.vue?vue&type=style&index=0&id=0c4fc3ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fc3ce",
  null
  
)

export default component.exports